export class LoggerLayout {
    code: string;
    message: string;
    userName: string;
    layoutIncidence: string;
    incidenceDate: Date;
    incidenceType: number;
}